import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useI18n } from '@runtime/core/i18n/i18n'
import { useAppStore } from '@runtime/core/store/appStore'
import { isPosterPrivate } from '@runtime/core/theme/posterAccess'
import { buildPlayShareUrl } from './buildPlayShareUrl'
import { shareApp, SHARE_MESSAGE_KEYS } from './shareApp'
export function usePlayShare() {
  const { t } = useI18n()
  const { pathname } = useLocation()
  const themeId = useAppStore(state => state.themeId)
  const [toast, setToast] = useState<{ message: string; tone: 'success' | 'error' } | null>(null)
  useEffect(() => {
    if (!toast) return
    const timer = window.setTimeout(() => setToast(null), 2200)
    return () => window.clearTimeout(timer)
  }, [toast])
  const share = async () => {
    const result = await shareApp({
      title: t('common.brandName'),
      text: t('home.shareText'),
      url: buildPlayShareUrl(pathname, themeId, isPosterPrivate(themeId)),
    })
    if (result !== 'cancelled')
      setToast({
        message: t(SHARE_MESSAGE_KEYS[result]),
        tone: result === 'unavailable' ? 'error' : 'success',
      })
  }
  return { share, toast }
}
